import type { ReactElement } from 'react'
import { NotReady, Page } from '@components'
import { useWebhooks, useTranslation } from '@front/model'
import { Group } from '@mantine/core'
import { AddWebhook } from './AddWebhook'
import { WebhooksList } from './WebhookList'
import { createFileRoute } from '@tanstack/react-router'

function Webhooks(): ReactElement {
  const { t } = useTranslation()
  const { data, isLoading, error, isFetching, refetch } = useWebhooks()

  if (isLoading || error || !data) return <NotReady data={data} error={error} id='Webhooks' isLoading={isLoading} />

  return (
    <Page>
      <Page.Heading isFetching={isFetching} refetch={refetch} title={t('Webhooks')}>
        <Group>
          <AddWebhook />
        </Group>
      </Page.Heading>
      <Page.Content scrollArea>
        <WebhooksList webhooks={data} />
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/integration/webhook/')({
  component: Webhooks,
})
